export default __webpack_public_path__ + "static/st-desktop-c6bb256e7b314d35953ffe14a11bfd82.png";